import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Seo from "@/components/shared/Seo";
import { LogIn } from "lucide-react";

const Login = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/admin");
  }, [user, loading, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <>
      <Seo title="Back-office — FACADES2build" description="Espace d'administration FACADES2build." />
      <div className="min-h-screen bg-f2b-black flex items-center justify-center px-6">
        <div className="max-w-md w-full text-center">
          <div className="flex items-baseline gap-1 justify-center mb-8">
            <span className="font-display text-white text-3xl font-bold">FACADES</span>
            <span className="font-display text-f2b-cyan text-3xl font-bold">2</span>
            <span className="font-display text-white text-3xl font-bold">build</span>
          </div>
          <p className="f2b-kicker text-f2b-cyan mb-4">Back-office</p>
          <h1 className="font-display font-bold text-white text-3xl mb-4">Administration du site</h1>
          <p className="text-white/60 mb-10">Connectez-vous avec votre compte Google autorisé pour gérer les éditions, le programme, les intervenants, les articles et les inscriptions.</p>
          <button onClick={login} data-testid="google-login-btn"
            className="w-full inline-flex items-center justify-center gap-3 bg-f2b-cyan text-f2b-black px-7 py-4 font-medium hover:shadow-[0_0_28px_rgba(0,190,255,0.5)] transition-all">
            <LogIn size={20} /> Se connecter avec Google
          </button>
          <a href="/" className="inline-block mt-8 text-white/50 text-sm hover:text-white">← Retour au site</a>
        </div>
      </div>
    </>
  );
};

export default Login;
